import { render } from "./TabNavigation.vue?vue&type=template&id=6ad9bde1"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=6ad9bde1&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__